const dependedFieldsPrefix = "depended-fields";

export const dependedFieldsActions = {
  UPDATE_DEPENDENCY: `${dependedFieldsPrefix}/update-dependency`,
  UPDATE_PERMITTED_VALUES: `${dependedFieldsPrefix}/update-permitted-values`,
};
